// extracted by mini-css-extract-plugin
export var list = "techtime-list-module--list--Cpugy";
export var listItem = "techtime-list-module--list-item--cVA7C";
export var selectedListItem = "techtime-list-module--selected-list-item--hjOrH";
export var hiddenListItem = "techtime-list-module--hidden-list-item--Pq1QA";
export var lecturesListWrapper = "techtime-list-module--lectures-list-wrapper--NbLbp";
export var projectTitle = "techtime-list-module--project-title--dVu8K";
export var teamCompositionWrapper = "techtime-list-module--team-composition-wrapper--L4GmS";